<!--Report component template, styling and functionality methods.


  This report is for the DART quiz report, not to be mixed up with the Industry 4.0 quiz report
-->
<template>
  <div>
    <div class="loadingDiv" v-if="!loaded">
      <br /><br /><br /><br /><br /><br />
      <div class="loader" style="margin: auto"></div>
      <br /><br /><br /><br /><br /><br />
    </div>

    

    <div v-if="loaded" id="reportDiv" class="animate-bottom">
      <div class="row">
          <div class="card-body" style="text-align: center;  color: rgb(0 155 219);">
            <h1>Your Business Maturity Profile</h1>
          </div>
      </div>

      <!-- MATURITY LEVELS -->

      <div id="show-levels" style="background-color: #e9e8e9; width: 100%">
        <h2 style=" color: rgb(0 155 219); text-align: center; padding: 30px">
          Your aspiration or vision
        </h2>


        <div class="container" style="padding-bottom: 15px;">
          <div class="row justify-content-md-center">
            <div class="col-md-12">
              <p>
              'Your next steps' are suggested actions for each of the elements to reach the next level of maturity and the road to excellence. The change programme suggestions are (at this stage) based on automated responses to the answers you have given.
              </p>
            </div>
            <!-- <div class="col-md-6">
              <img src="../assets/diagram1.png" alt="Diagram 1">
            </div> -->
          </div>
        </div>

        <div class="container" style="padding-bottom: 15px">
          <div class="row justify-content-md-center">
            <div class="card">
              <div class="card-body">
                <dl class="row">
                  <dt class="col-sm-3" style="text-align: center">
                    <span class="align-middle">
                      Current:
                      <p style="font-size: 25px;  color: rgb(0 155 219);">
                        {{ this.currentMatLevelIndicator }}
                      </p>
                    </span>
                  </dt>
                  <dd class="col-sm-9 text-justify" style="font-size: 20px">
                    {{ this.currentMatLevelBehavior }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div class="container" style="padding-bottom: 15px">
          <div class="row justify-content-md-center">
            <div class="card">
              <div class="card-body">
                <dl class="row">
                  <dt class="col-sm-3" style="text-align: center">
                    Your Aim:<br />
                    <p style="font-size: 25px;  color: rgb(0 155 219);">
                      {{ this.desiredMatLevelIndicator }}
                    </p>
                  </dt>
                  <dd class="col-sm-9 text-justify" style="font-size: 20px">
                    {{ this.desiredMatLevelBehavior }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <br />

        <!--
        <div class="container" style="padding-bottom: 25px">
          <table class="table" style="width: 100%">
            <tr>
              <th>Maturity Indicator</th>
              <th>Behavior</th>
            </tr>
            <tr
              v-for="matLevel in matLevels"
              :key="matLevel.level"
              class="single-mat-level"
            >
              <td>{{ matLevel.indicator }}</td>
              <td>{{ matLevel.behavior }}</td>
            </tr>
          </table>
        </div>
        -->
      </div>


      <div style="width: 100%; text-align: center">
        

        <div class="container">
          <h2 style=" color: rgb(0 155 219); text-align: center; padding: 30px">
              Your Business Maturity Profile Report
          </h2>
          <div class="container" style="padding-bottom: 15px;">
              <div class="row justify-content-md-center">
                <div class="col-md-12">
                  <p>
                    Your business profile consists of a maturity index along with an organisation element breakdown. 
                    The maturity indexing is based on five ‘fixed domains’ from Pioneering through to operational excellence. Each of the five domains must be passed through. The levels are based on Ledet (Manufacturing Game), PEMM, Leiden University, UK HSE Cultural maturity, ISO 9004 (further details available on request). 
                    The organisation breakdown is based on ISO 55000 Asset Management, however is also aligned structurally to ISO’s 9000, 14000, 45000 and 27000. 
                    The scaling gives insights into the type of change programme that would be most appropriate to your business along with focus areas.
                  </p>
                </div>
              </div>
            </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="row">
                <div class="container">
                  <div class="card" style="border-color: white">
                    <div
                      class="card-body"
                      style="text-align: center; font-size: 20px"
                    >
                      Your Organisation is described as
                      <p style="font-size: 40px;  color: rgb(0 155 219);">
                        <strong>
                          {{ this.changeCapability }}
                        </strong>
                      </p>
                      <!-- {{ this.changeCapabilityDescription }} -->
                    </div>
                  </div>
                </div>
              </div>

              <div style="padding-top: 5px; width: 100%">
                <div class="card">
                  <div
                    class="card-body"
                    style="text-align: center; font-size: 20px"
                  >
                    Your Overall Change Index:<br />
                    <strong>{{ this.changeIndex }}%</strong>
                  </div>
                </div>
              </div>

              <div class="row" style="padding-top: 10px">
                <div class="col-sm">
                  <div class="card">
                    <div
                      class="card-body"
                      style="text-align: center; font-size: 20px"
                    >
                      Your Current Score:<br />
                      <strong>{{ this.currentStateAverage }}</strong>
                    </div>
                  </div>
                </div>

                <div class="col-sm">
                  <div class="card">
                    <div
                      class="card-body"
                      style="text-align: center; font-size: 20px"
                    >
                      Your Target Score:<br />
                      <strong>{{ this.desiredStateAverage }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div id="radarchart">
                <radar-chart
                  v-if="loaded"
                  id="radargraph"
                  :chartdata="this.newData"
                  :options="this.options"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- END OF FIRST SECTION -->

        <!-- PERSONALITY DESCRIPTION  -->
        <br />
        <hr />
        <br />
        <div class="row">
          <div class="container">
            <h2 style=" color: rgb(0 155 219); text-align: center; padding: 30px">
              Your Business Personality Report
            </h2>
            <div class="container" style="padding-bottom: 15px;">
              <div class="row justify-content-md-center">
                <div class="col-md-12">
                  <p>
                    Your 'Business' personality gives a unique insight into your business operation. The algorithms are based on human behaviour research dating back to ancient philosophy but more recent incarnations (evolution is given opposite). These have been adapted to whole organisations and give you the opportunity to understand more about how you interface with other business entities. 
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4">
                <img
                  class="center"
                  v-if="this.personalityDescription === 'Rapid Accelerators'"
                  style="max-width: 350px"
                  src="../assets/img/acc.png"
                />
                <img
                  class="center"
                  v-if="this.personalityDescription === 'Balanced'"
                  style="max-width: 350px"
                  src="../assets/img/bal.png"
                />
                <img
                  class="center"
                  v-if="this.personalityDescription === 'Controllers'"
                  style="max-width: 350px"
                  src="../assets/img/cot.png"
                />
                <img
                  class="center"
                  v-if="this.personalityDescription === 'Masters of your Craft'"
                  style="max-width: 350px"
                  src="../assets/img/cra.png"
                />
                <img
                  class="center"
                  v-if="
                    this.personalityDescription === 'Curators of the Present'
                  "
                  style="max-width: 350px"
                  src="../assets/img/cur.png"
                />
                <img
                  class="center"
                  v-if="this.personalityDescription === 'Fixers'"
                  style="max-width: 350px"
                  src="../assets/img/fix.png"
                />
                <img
                  class="center"
                  v-if="
                    this.personalityDescription === 'Purveyors of the Future'
                  "
                  style="max-width: 350px"
                  src="../assets/img/fut.png"
                />
                <img
                  class="center"
                  v-if="this.personalityDescription === 'Listeners'"
                  style="max-width: 350px"
                  src="../assets/img/lis.png"
                />
                <img
                  class="center"
                  v-if="
                    this.personalityDescription ===
                    'Protectors of the Reasonable'
                  "
                  style="max-width: 350px"
                  src="../assets/img/rea.png"
                />
              </div>

              <div class="col-lg-8">
                <div class="card" style="border-color: white">
                  <div
                    class="card-body"
                    style="text-align: center; font-size: 20px"
                  >
                    Your Business Personality is described as
                    <p style="font-size: 40px;  color: rgb(0 155 219);">
                      <strong>
                        {{ this.personalityDescription }}
                      </strong>
                    </p>
                    {{ this.personalityLongDescription }}
                  </div>

                  <div class="card mb-3" style="border-color: white">
                    <div
                      class="card-body"
                      style="text-align: center; font-size: 20px"
                    >
                      <strong>Your Traits</strong><br />
                      {{ this.personalityTraits }}
                    </div>
                  </div>
                  <div class="card mb-3" style="border-color: white">
                    <div
                      class="card-body"
                      style="text-align: center; font-size: 20px"
                    >
                      <strong>Typical Profiles</strong><br />
                      {{ this.personalityTypicalProfile }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- NEXT STEPS-->

      <h2 style=" color: rgb(0 155 219); text-align: center; padding: 30px" >
        Recommended next steps for initiating business performance improvements
      </h2>

      <div class="container" style="padding-bottom: 15px;">
        <div class="row justify-content-md-center">
          <div class="col-md-12">
            <p>
            'Your next steps' are suggested actions for each of the elements to reach the next level of maturity and the road to excellence. The change programme suggestions are (at this stage) based on automated responses to the answers you have given.
            </p>
          </div>
        </div>
      </div>

      <div hidden id="nextsteps">
        <h2 style=" color: rgb(0 155 219); text-align: center; padding: 30px">
          Your Next Steps
        </h2>
        <div id="next-steps" class="container">
          <table class="table" style="width: 100%">
            <tr>
              <th><strong>Sector</strong></th>
              <th>Next Step Recommendation</th>
            </tr>
            <tr>
              <td><strong>Audit and Review</strong></td>
              <td>{{ this.nextStepAudit }}</td>
            </tr>
            <tr>
              <td><strong>Context</strong></td>
              <td>{{ this.nextStepContext }}</td>
            </tr>
            <tr>
              <td><strong>Improvement</strong></td>
              <td>{{ this.nextStepImprovement }}</td>
            </tr>
            <tr>
              <td><strong>Leadership</strong></td>
              <td>{{ this.nextStepLeadership }}</td>
            </tr>
            <tr>
              <td><strong>Learning</strong></td>
              <td>{{ this.nextStepLearning }}</td>
            </tr>
            <tr>
              <td><strong>Operation</strong></td>
              <td>{{ this.nextStepOperation }}</td>
            </tr>
            <tr>
              <td><strong>Performance</strong></td>
              <td>{{ this.nextStepPerformance }}</td>
            </tr>
            <tr>
              <td><strong>Planning</strong></td>
              <td>{{ this.nextStepPlanning }}</td>
            </tr>
            <tr>
              <td><strong>Support</strong></td>
              <td>{{ this.nextStepSupport }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div id="nextSteppers" class="container" style="font-size: 20px">
        <!-- Vertical Steppers -->
        <div class="row mt-1">
          <div class="col-md-12">
            <!-- Stepers Wrapper -->
            <ul class="stepper stepper-vertical">
              <li class="active">
                <!--Section Title -->
                <a href="#!">
                  <span class="circle">&#10003;</span>
                  <span class="label">Audit and Review</span>
                </a>
                <!-- Section Description -->
                <div class="step-content grey lighten-3">
                  {{ this.nextStepAudit }}
                </div>
              </li>

              <li class="active">
                <!--Section Title -->
                <a href="#!">
                  <span class="circle">&#10003;</span>
                  <span class="label">Context</span>
                </a>
                <!-- Section Description -->
                <div class="step-content grey lighten-3">
                  {{ this.nextStepContext }}
                </div>
              </li>

              <li class="active">
                <!--Section Title -->
                <a href="#!">
                  <span class="circle">&#10003;</span>
                  <span class="label">Improvement</span>
                </a>
                <!-- Section Description -->
                <div class="step-content grey lighten-3">
                  {{ this.nextStepImprovement }}
                </div>
              </li>

              <li class="active">
                <!--Section Title -->
                <a href="#!">
                  <span class="circle">&#10003;</span>
                  <span class="label">Leadership</span>
                </a>
                <!-- Section Description -->
                <div class="step-content grey lighten-3">
                  {{ this.nextStepLeadership }}
                </div>
              </li>

              <li class="active">
                <!--Section Title -->
                <a href="#!">
                  <span class="circle">&#10003;</span>
                  <span class="label">Learning</span>
                </a>
                <!-- Section Description -->
                <div class="step-content grey lighten-3">
                  {{ this.nextStepLearning }}
                </div>
              </li>

              <li class="active">
                <!--Section Title -->
                <a href="#!">
                  <span class="circle">&#10003;</span>
                  <span class="label">Operation</span>
                </a>
                <!-- Section Description -->
                <div class="step-content grey lighten-3">
                  {{ this.nextStepOperation }}
                </div>
              </li>

              <li class="active">
                <!--Section Title -->
                <a href="#!">
                  <span class="circle">&#10003;</span>
                  <span class="label">Performance</span>
                </a>
                <!-- Section Description -->
                <div class="step-content grey lighten-3">
                  {{ this.nextStepPerformance }}
                </div>
              </li>

              <li class="active">
                <!--Section Title -->
                <a href="#!">
                  <span class="circle">&#10003;</span>
                  <span class="label">Planning</span>
                </a>
                <!-- Section Description -->
                <div class="step-content grey lighten-3">
                  {{ this.nextStepPlanning }}
                </div>
              </li>

              <li class="active">
                <!--Section Title -->
                <a href="#!">
                  <span class="circle">&#10003;</span>
                  <span class="label">Support</span>
                </a>
                <!-- Section Description -->
                <div class="step-content grey lighten-3">
                  {{ this.nextStepSupport }}
                </div>
              </li>
            </ul>
            <!-- /.Stepers Wrapper -->
          </div>
        </div>

        <br />
      </div>

      <hr />
      <div class="container">
        <div class="row justify-content-center" style="text-align: center">
          <div class="card col-lg-7" style="border-color: white">
            <p>
            <i>
              If you wish to save your results, simply use your browser function to save the page. Of course we would love to hear from you about your journey to excellence. 
            </i>
            </p>
          </div>
        </div>
      </div> 

      <!-- QUOTE -->
      <div style="background-color: #e9e8e9; width: 100%; font-size: 20px">
        <div class="container" style="padding: 30px">
          <div class="card">
            <div class="card-header">Doesn't sounds quite right?</div>
            <div class="card-body">
              <blockquote class="blockquote mb-0">
                <p>
                  <i>
                    It would be perfectly natural to over inflate the assessment
                    scores; the reality of the as is situation may not be
                    palletable to most. However, a frank, honest look into the
                    process & systems mirror will yield a credible base line to
                    work from.
                  </i>
                </p>
                <footer class="blockquote-footer">
                  Add Energy's Learning Delivery Manager
                </footer>
              </blockquote>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>


<script>
// Import the radar visualisation from the .vue file.
import RadarChart from "./RadarChart";

// Exporting should kinda be seen as "This is how I'm gonna package up my page into a box for when it needs to be used".
// All of the events and functions required on the page are put into this bit.
export default {
  data() {
    return {
      fRow : null,
      from: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.from = from;
    });
  },

  components: {
    RadarChart,
  },

  beforeCreate() {
    //this.HOST_URL = this.$HOST_URL;
  },

  // As soon as the page instance is created, start parsing the params & values passed via the URL.
  created() {
    // Get the query section from the URL
    const queryString = window.location.search;
    // Parse the query section into a URLSearchParams object. This object will do most of the work for us when it comes to getting key value pairs.
    const urlParams = new URLSearchParams(queryString);

    // Get all of the data from the URL via their keys.
    this.cContext = parseInt(urlParams.get("q1"));
    this.cLeadership = parseInt(urlParams.get("q2"));
    this.cPlanning = parseInt(urlParams.get("q3"));
    this.cSupport = parseInt(urlParams.get("q4"));
    this.cOperation = parseInt(urlParams.get("q5"));
    this.cPerformance = parseInt(urlParams.get("q6"));
    this.cAudit = parseInt(urlParams.get("q7"));
    this.cImprovement = parseInt(urlParams.get("q8"));
    this.cLearning = parseInt(urlParams.get("q9"));
    

    this.dContext =  parseInt(urlParams.get("q1F"));
    this.dLeadership = parseInt(urlParams.get("q2F"));
    this.dPlanning =  parseInt(urlParams.get("q3F"));
    this.dSupport =  parseInt(urlParams.get("q4F"));
    this.dOperation =  parseInt(urlParams.get("q5F"));
    this.dPerformance =  parseInt(urlParams.get("q6F"));
    this.dAudit =  parseInt(urlParams.get("q7F"));
    this.dImprovement =  parseInt(urlParams.get("q8F"));
    this.dLearning =  parseInt(urlParams.get("q9F"));
    
    // Get the average scores for the user's Current and Desired levels
    this.currentStateAverage = Math.floor((this.cSupport + this.cPlanning + this.cPerformance + this.cOperation + this.cLearning + this.cLeadership + this.cImprovement + this.cContext + this.cAudit )/9);
    this.desiredStateAverage = Math.floor((this.dSupport + this.dPlanning + this.dPerformance + this.dOperation + this.dLearning + this.dLeadership + this.dImprovement + this.dContext + this.dAudit)/9);

    this.cMaturityLevel = this.currentStateAverage;
    this.dMaturityLevel = this.desiredStateAverage;
    this.currentMatLevelID = this.currentStateAverage;
    this.desiredMatLevelID = this.desiredStateAverage;

    // Setup the current & desired maturity indicator and behaviour texts
    for (let i=0;i<2;i++){
        var ind;
        var beh;
        var switchVar = i==1 ? this.desiredStateAverage: this.currentStateAverage
        switch(switchVar) {
		
          case 1: 
            ind = "Emerging";
            beh = "In the absence of a plan, procedures or processes you are relying on people in your business to get things done. However, there is possibly an absence of legal obligations, local regulations codes and standards so you may want to go check your business (or get someone to do it for you)";
            break;
          
          case 2: 
            ind = "Managing";
            beh ="As an organisation you are highly responsive and reactive to your customers demands. You have a Plan and may even have a Management System with a Quality Assurance Focal Point however. Services and products are often not what you would like them to be. You may be getting disappointed customers as contracts are not always understood or adhered to. Codes and standards are a bit hit and miss. You are getting towards being effective in delivery";
            break;
            
          case 3: 
            ind = "Involving";
            beh = "You are planning and developing and have introduced some checking and inspection practices and are now effective in delivery. You are with about 75% of organisations and output meets most of the requirements of your customers, codes and standards. However you are not efficient and tend to waste money on silly mistakes and occasionally systemic failures are not spotted";
            break;
            
          case 4:
            ind = "Cooperating";
            beh = "You follow good practices and regularly review your performance by tracking defects, customer feedback. You have an improvement plan that is resourced, implemented and accepted by some of the workforce. You are efficient and most customers are delighted with the services and products you provide. There is an increasing demand to produce more for less and commoditise your service";
            break;
            
          case 5:
            ind = "Continually Improving";
            beh = "You are consistent in delivery and recognised as such. Stakeholders are delighted (Employees, Suppliers, Shareholders, Customers) and even your competitors acknowledge and aspire to follow your lead. However, Leadership now wants to reduce costs and increase profit";
            break;
        }

        if (i == 1){
            this.desiredMatLevelIndicator = ind;
            this.dMaturityIndicator = ind;
            this.desiredMatLevelBehavior = beh;
        } else{
            this.currentMatLevelIndicator = ind;
            this.cMaturityIndicator = ind;
            this.currentMatLevelBehavior = beh;
        }
    }
    



    // Get the next steps for each of the sections.
    this.nextStepAudit = getStep("audit", this.cAudit);
    this.nextStepContext = getStep("context", this.cContext);
    this.nextStepImprovement = getStep("improvement", this.cImprovement);
    this.nextStepLeadership = getStep("leadership", this.cLeadership);
    this.nextStepLearning = getStep("learning", this.cLearning);
    this.nextStepOperation = getStep("operation", this.cOperation);
    this.nextStepPerformance = getStep("performance", this.cPerformance);
    this.nextStepPlanning = getStep("planning", this.cPlanning);
    this.nextStepSupport = getStep("support", this.cSupport);

    // getStep() retrieves the corresponding text containing suggestions on how to level up a user's maturity level.
    // A sector (part number) is provided to get the relevant step for the part.
    function getStep(sector, score) {
        switch (sector) {  
          case "context":
            switch (score) {
              case 1:
                return "You are a Pioneer organisation so you should start to document your understanding of how the organisation fits into the business environment. This information may well be in the heads of the entrepreneurs or original team.  Maybe consider Political, Environment, Social, Technical, Legal and Economic pressures and take a look at your real business objectives. Do this with other people on your team.";
              case 2:
                return "You should take a look at your business plan (in your library) which should contain external drivers (pressures and issues) and internal capabilities along with objectives (these should reflect corporate obligations as well as financial). Your stakeholders need to be identified, their needs documented and a communication plan developed. These stakeholders are your workforce and functional groups (for example HR, Logistics, Finance but also customers, suppliers, government and other authorities. These activities will start the development of your Asset Management System.";
              case 3:
                return "You need to identify how your organization sits within its environment (internal and external), any relevant laws and regulations, and your stakeholders both inside and outside the organization in relation to your Asset Management System (AMS). A Strategic Asset Management Plan (SAMP) will need to be developed. This should contain the objectives for your AMS and support your organization’s objectives. You will also need to decide what is covered by your AMS and just as importantly, what isn’t. This scope should be made available as “documented information”. In doing this you may need to consider your appetite for risk and the relevant legal and regulatory requirements for your organization. It may be useful to create an asset management register when doing this. Finally, you will need to make sure you continually improve your AMS through feedback with your stakeholders.";
              case 4:
                return "You will be seeing how communicating the internal and external context of your organisation to your stakeholders has an empowering effect on your team. Reinforce the 'wins' through communications and encourage feedback.";
              case 5:
                return "The Context of your organisation is well understood by all your employees and external stakeholders. Continually scan your business environment. Internal (process, people, plant) capabilities, customers, suppliers, competitors and also the broadscale (global factors) PESTLE assessment.";
            }
          
          case "leadership": 
            switch (score) {
              case 1:
                return "Your leadership are probably the owners or original pioneers that started the business and have huge personal commitment and drive. The culture and values are by action but as more people join the organisation the policies, organisational roles and responsibilities need to be documented.";
              case 2:
                return "Top management should appoint a focal point to create an asset management system aligned to the objectives of the organisation. One of the key documents should be the policy which includes, values, expectations, planning, work execution, checking and improvement.";
              case 3:
                return "Define the roles and responsibilities of top management, which is the group of people who direct and control your organization at the highest level in relation to the asset management system. They must show their commitment with respect to the AMS. This includes, ensuring your AMS is compatible with the strategic direction of the organization and that your asset management requirements are integrated into your business processes. A culture of collaboration and continual improvement should also be actively supported by top management as well as ensuring that the right resources are made available. An asset management policy will need to be established which must be communicated and made available as documented information. Top management should assign responsibility for the planning, establishment, implementation and performance monitoring of the asset management system. They are also responsible for maintaining and updating the SAMP. And finally, you will also need to show how you continually improve your asset management.";
              case 4:
                return "You should have good documented definition of the organisation's roles and responsibilities. You need to check these against the business environment and change to the organisation objectives. Leadership should be communicating consistent messages.";
              case 5:
                return "Leadership (Top Management) are demonstrably committed to Asset Management and systematic delivery of policy. Continually review the policies for changes to the business environment.";
            }


          case "planning": 
            switch (score) {
              case 1:
                return "Your organisation reacts to demand and is mostly successful in meeting client objectives through hard work. This hard work is sometimes wasted due to time, cost or Asset issues; so having a rough short term plan would help in smoothing resource demands and improving schedule compliance, cost constraints and defect elimination. Appoint a focal point for the 'Plan'";
              case 2:
                return "Your planning process should include business priorities based on the objectives of the organisation. These may well include Cost, Production, Schedule, Asset, Environmental, Safety and Health elements of risk. Ask internal stakeholders to provide probability of demand as well as load (probability v. consequence). The output is often contained within the CMMS systems.";
              case 3:
                return "You will need to consider the issues and requirements identified in the “Context of the Organization” clause and consider the risks and opportunities these present in relation to your AMS. You will need to specify your asset management objectives and ensure that they are in-line with your organizational goals. You also need to show how you will achieve these objectives, address stakeholder needs and requirements, and address risks and opportunities. This may mean working with other departments in your organization. A Strategic Asset Management Plan (SAMP) needs to be developed and you will need to consider the whole life-cycle of an asset. You will also need to consider a number of factors including, the risks and priorities for your organization, the effect on stakeholders, the information and knowledge needs, and the resourcing requirements including any special tools or equipment that could be needed to maintain an asset. When considering this you may find it useful to read ISO 31000 for further information on risk management.";
              case 4:
                return "Review your threat and opportunity register on a regular basis with internal stakeholders. Include these on a dynamic prioritised long term plan. Provide appropriate information to external satkeholders to improve efficiency of delivery for example use of Enterprise Asset Management (EAM) Applications may support this.";
              case 5:
                return "Monitor availability of assets, risks and root cause processes on a continual basis.";
            }
          case "support": 
            switch (score) {
              case 1:
                return "Your supporting functions and interfaces are responding to demands and rely on the knowledge and skills of a few team members to keep ahead. Documented information, communications and competence of the team on the assets need to be improved to be more effective. Establish a library and document control function. Develop a training program";
              case 2:
                return "Develop an improvement plan that encompasses both process and people aligned to international standards. You may want to look as a start at Quality (9000), Occupational Health (35000), Environmental (14000), Asset Management (55000) and Information Security (27000). Consider technology support to improve effectiveness of information distribution but beware of overly complex systems.";
              case 3:
                return "You need to consider the resources and competencies needed to establish, maintain and continually improve the asset management system. You will need to ensure that the people in your organization who work in the field of asset management are competent. You will need to prove they have knowledge, skills and behaviour needed to do the jobs correctly. Training needs analysis, both for the present and for the future, should be carried out. Make sure that the right information is shared with the right people inside and outside the organization at the right time. Information about the assets must be retained and the type of information that is kept depends on the type of asset and its purpose. Documents relating to asset management should be controlled, developed, approved, and maintained. Using appropriate technology.";
              case 4:
                return "Maintain and retain the following Asset management system documentation maximise the use of technology to minimise cost and maximise control: The scope of the Asset management system ; Information necessary to support the operation of AMS processes ; The Asset policy; The Asset objectives ; Evidence of fitness for purpose of monitoring and measuring resources ; Evidence of the basis used for calibration of the monitoring and measurement resources ; Evidence of competence of people doing work under the control of the organization that affects the performance and effectiveness of the AMS; Documented information required by the AMS ; Results of the review and requirements for the products and services ; Records to demonstrate compliance with design and development requirements; Records of design and development inputs; Records of the activities of design and development controls; Records of design and development outputs ; Design and development changes, including the results of the review and the authorization of the changes and necessary actions; Records of the evaluation, selection, monitoring of performance and re-evaluation of external providers and any actions arising ; Evidence of the unique identification of outputs when traceability is a requirement ; Records of property of the customer or external provider that is lost, damaged or non-conforming and of its communication to the owner ; Results of the review of changes for production or service provision, the persons authorizing the change, and necessary actions taken; Records of authorized release of products for delivery to the customer including acceptance criteria and traceability to the authorizing person(s) ; Records of non-conformities, actions taken, concessions and the identity of the authority deciding the action in respect of the nonconformity ; Results of the evaluation of the performance and the effectiveness of the AMS ; Evidence of the implementation of the audit programme and the audit results; Evidence of the results of management reviews; Evidence of the nature of the nonconformities and any subsequent actions taken; Results of any corrective actions ";
              case 5:
                return "You need to monitor very carefully that your supporting organisation does not become overly complex and is a burden on your organisation.";
            }

          case "operation": 
            switch (score) {
              case 1:
                return "Your operation may well be focused on delivery to demand whatever that may be. You should start to develop operational processes and procedures which identify roles and responsibilities, resource requirements (inc competence) and technical standards for each activity required to meet demand.";
              case 2:
                return "Introduce standard work management processes (plan, do, check, act) for each activity required to deliver to your customer. Ensure Management of change is included and enrol any outsourced work into the program. Consider using internationally recognised standards to reference your processes and use technology solutions in support of these activities. (CMMS systems for example).";
              case 3:
                return "Make sure you measure the effectiveness of the system to achieve the intended outcomes of the Business. You’ll also need to consider the impact of change on your AMS, and you will need to implement a comprehensive change management process making sure that it is communicated to all relevant parties. If work is sent off site or services subcontracted, it is still your responsibility to ensure these processes are controlled and what the responsibilities and authorities are in relation to this work. Documented and formal processes for outsourcing are required and you must monitor the performance of these activities. This is because it can be of a complex nature and can pose a high risk to the organization if not managed effectively.";
              case 4:
                return "You have established plans and controls for your activities. Use interface management, customer relationships, outsourcing practices to refine and enhance efficiency (ISO 41012, ISO 44001). Provide normative references to key processes to align with internation requirements. Ensure management of change processes are embedded through regular review and improve events.";
              case 5:
                return "Monitor operational performance and assure business objectives are aligned along with any legal or standard refresh. Provide feedback via training.";
            }
            
          case "performance": 
            switch (score) {
              case 1:
                return "Performance maybe measured via income and customer complaint. Basic measures of time, cost, quality should be adopted. Examples are; Time being either a schedule constraint or order to delivery. Cost is the cost per unit and quality is the number of reported defects per unit.";
              case 2:
                return "Performance Indicators should be developed that are aligned to the business goals and prioritisation systems. You should also consider leading and lagging indicators (input and output) for your activities. For example a defect requires rework which has an impact on cost. For Maintenance and inspection of assets consider using ISO 14224 or equivalent to collect and exchange data with your Inspection or Maintenance Applications.";
              case 3:
                return "To optimize the effectiveness of the asset management system by identifying the most appropriate methods of monitoring, measurement, and analysis. Performance indicators should be developed to measure the effectiveness of the system. These measurements could be quantitative, qualitative, financial, or non-financial and be arranged to support the business objectives in a lead/lag hierarchy. Consider using risk based techniques for identification of monitoring intervals for Asset performance.";
              case 4:
                return "To be more effective and efficient, review and map performance against your business requirements (value drivers) and internal or external benchmarking data. Use external benchmark targets and use of advanced risk based techniques (RCM/RBI/SIL/FMECA) to set reliability and/or availability targets.";
              case 5:
                return "Benchmark your activities against customers, suppliers and competitors.";
            }
          
          case "audit": 
            switch (score) {
              case 1:
                return "Create and deploy simple quality check sheets for each of the key activity processes to users. Consider adopting simple technology to collate and potentially trend returns of the results.";
              case 2:
                return "Build an annual audit and review plan and allocate dedicated resources. Measure defects and customer complaints. Consider adopting a scaled maturity index to support tick-box checks. Keep records of; Records of non-conformities, actions taken, concessions and the identity of the authority deciding the action in respect of the nonconformity ; Results of the evaluation of the performance and the effectiveness of the AMS ; Evidence of the implementation of the audit programme and the audit results;";
              case 3:
                return "You will also need to evaluate and report on the effectiveness of your processes for managing risks and opportunities. Use scales (ISO 9004, PEMM etc) to identify maturity and rates of change. Internal audit will need to be regularly carried out as will management reviews. Management reviews should consider the suitability, adequacy, and effectiveness of the AMS. These meetings could also be used as an opportunity to identify improvements and ways of managing assets more effectively. Documented information of these reviews should be kept";
              case 4:
                return "Put in place 3 level assurance (Local, Asset, Corporate) in a seamless spectrum of assurance activity that includes; Asset (Equipment) health, Process Maturity and Competence of personnel.";
              case 5:
                return "Align people, process, plant leading maturity to business lagging performance indicators.";
            }
          
            
          case "improvement": 
            switch (score) {
              case 1:
                return "You may well be correcting customer or inspection identified defects as they occur. You should start to collect records of these defects and analyse these to establish root cause and create a corrective action. You will need to nominate resources to do this and consider adopting technology solutions in support.";
              case 2:
                return "You should establish an assurance capability for activities and products often under the remit of HSE, QA, QC, Maintenance or Inspection functions. Personnel should be trained in RCA techniques, Quality Assurance, HSE, Inspection (various) as appropriate to the activities being performed. You should keep records of: Evidence of the results of management reviews; Evidence of the nature of the nonconformities and any subsequent actions taken; Results of any corrective actions ";
              case 3:
                return "Your AMS needs to be continually improved to drive business performance. Nonconformities and corrective actions are dealt with systematically. These need to be reviewed and corrected and, if necessary, any approved changes to the AMS should be made. Documented information should be kept as a record of this. Consider adopting preventative and predictive activity based on monitoring actions and the use of technology to support improvement.";
              case 4:
                return "Adopt techniques to drive improvements based on the analysis of events and performance triggers. Apply appropriate methods and software solutions including but not limited to RCA, RCM, FMECA, RBI, SIL, RAM.";
              case 5:
                return "You should drive towards integration of systems and simplification of process using LEAN process modelling.";
            }
            
          case "learning": 
            switch (score) {
              case 1:
                return "You will be providing training against regulation and customer demand possibly on an attendance only basis. You should monitor and measure requirements to keep upto date with changes in working location and scope of the requirements. In particular leadership need to understand the legal requirements for competence in the region of work.";
              case 2:
                return "You should align your training to the business objectives giving knowledge, skill and behavioural requirements to fulfil the job. Consider using technology to track individual and collective competence for internal and outsourced activity.";
              case 3:
                return "Competence Preventive action should take place to proactively identify any potential failures on the performance of people and assets and a procedure (Training Needs Analysis) for this should be developed. Finally, a clear methodology that delivers continual improvement should be developed and implemented using appropriate technology for efficiency. Competence Standards should adopt industry segment requirements along with trade and company needs.";
              case 4:
                return "Align all competence improvements to a single integrated plan for the asset and embed within the asset business plan. Delivery should be blended and adopt a 'just-in-time' approach where possible.";
              case 5:
                return "Your staff competence should be driven by current and future needs of the business and its stakeholders. This includes your staff, customers, regulators and may be influenced by your competitors (they may provide enhanced offerings).";
            }
          }
    }


    // Calculate some personality Vectors (Jayne made these I think)
    var currentXVector = this.cLeadership + this.cPerformance + this.cLearning - this.cPlanning- this.cImprovement- this.cSupport;
    var currentYVector = this.cContext + this.cLeadership - this.cLearning - this.cAudit - this.cPlanning + this.cSupport;

    // 0,0 balanced If both are equal
    if(currentXVector == 0 && currentYVector == 0) {
        this.personalityDescription = "Balanced";
        this.personalityLongDescription = "You value consistency and concentrate on what is within your power";
        this.personalityTraits = " Careful, steady";
        this.personalityTypicalProfile = "Government Services, Police";
    }
    //0,1 listeners
    else if(currentXVector == 0 && currentYVector > 0) {
        this.personalityDescription = "Listeners";
        this.personalityLongDescription = "You seek to understand problems and provide specialised guidance. You value nuance and contextualise your information for specific audiences";
        this.personalityTraits = "Creative, introspective, informative";
        this.personalityTypicalProfile = "Advertising/ Creative Agencies, Coaching";
    }
    // 1,0 Rapid accelerators 
    else if(currentXVector > 0 && currentYVector == 0) {
        this.personalityDescription = "Rapid Accelerators";
        this.personalityLongDescription = "You quickly create value and prefer speed to insight over depth";
        this.personalityTraits = " Performance-focused, High-energy, Capable of quick pivoting";
        this.personalityTypicalProfile = " Start-ups, Research laboratories";
    }
    // 0,-1	Controllers
    else if(currentXVector == 0 && currentYVector < 0) {
        this.personalityDescription = "Controllers";
        this.personalityLongDescription = "You seek truth and accuracy. You value transparency and focus on transactional information as opposed to contextual information";
        this.personalityTraits = "Detail-oriented, stable, organised";
        this.personalityTypicalProfile = "Audit firms, Law firms";
    }
    // -1,0 Fixers
    else if(currentXVector < 0 && currentYVector == 0) {
        this.personalityDescription = "Fixers";
        this.personalityLongDescription = "You seek to improve upon the present. You focus on mitigating actions to improve the future state, and you build upon current skills/ technology";
        this.personalityTraits = "Enterprising, value-oriented, flexible";
        this.personalityTypicalProfile = "Niche consultancy, financial services";
    }
    
    //if (1,1) Purveyors
    else if(currentXVector > 0 && currentYVector > 0) {
        this.personalityDescription = "Purveyors of the Future";
        this.personalityLongDescription = "You interpret and add meaning to the available information, while focusing on logic and consistency of the future solution";
        this.personalityTraits = "Focused, Efficient, Practical, Problem solving";
        this.personalityTypicalProfile = "Engineering Contractors, Tech Companies";
    }
    
    // 1,-1 Protectors
    else if(currentXVector > 0 && currentYVector < 0) {
        this.personalityDescription = "Protectors of the Reasonable";
        this.personalityLongDescription = "You interpret and add meaning to the available information, while staying open and accommodating to individuals and special circumstances";
        this.personalityTraits = "Quiet and calm, content, consistent";
        this.personalityTypicalProfile = "Accountants, Schools, Universities, Operators";
    }	
    
    // -1, -1 Curators
    else if(currentXVector < 0 && currentYVector < 0) {
        this.personalityDescription = "Curators of the Present";
        this.personalityLongDescription = "You focus on the information available, while acting to resolve and decide current issues";
        this.personalityTraits = "Developing, cautious, organized, preventing problems";
        this.personalityTypicalProfile = "Government, Regulators, Inspection, Hospitals";
    }
    //if (-1,+1) Masters of craft
    else //if (currentXVector < 0 && currentYVector > 0) {
    {
        this.personalityDescription = "Masters of your Craft";
        this.personalityLongDescription = "Your focus is on the information available, while staying open to new and diverse information types";
        this.personalityTraits = "Pioneer, social, influential, quick to respond, spontaneous";
        this.personalityTypicalProfile = "Shops, SME's, Sales, Marketing, Consulting";
    }		


    
    this.changeIndex = Math.round((this.currentStateAverage*100)/5);
    
    if(this.changeIndex < 20) {
        this.changeCapability = "Pathological";
        this.changeCapabilityDescription = " ";
    }
    else if(this.changeIndex < 40) {
        this.changeCapability = "Pioneer";
        this.changeCapabilityDescription = " ";
    }
    else if(this.changeIndex < 65) {
        this.changeCapability = "Effective";
        this.changeCapabilityDescription = " ";
    }
    else if(this.changeIndex < 85) {
        this.changeCapability = "Efficient";
        this.changeCapabilityDescription = " ";
    }
    else {
        this.changeCapability = "Best in Class";
        this.changeCapabilityDescription = " ";		
    }









    this.newData = {
    labels: [
        "Context",
        "Leadership",
        "Planning",
        "Support",
        "Operation",
        "Performance",
        "Audit and Review",
        "Improvement",
        "Learning",
    ],
    datasets: [
        {
        label: "Where you are",
        backgroundColor: "rgba(255, 99, 132, 0.2)",
        borderColor: "rgb(255, 0, 132)",
        pointBackgroundColor: "rgb(255, 99, 0)",
        data: [
            this.cContext,
            this.cLeadership,
            this.cPlanning,
            this.cSupport,
            this.cOperation,
            this.cPerformance,
            this.cAudit,
            this.cImprovement,
            this.cLearning,
        ],
        },
        {
        label: "Where you want to be",
        backgroundColor: "rgba(54, 162, 235, 0.2)",
        borderColor: "rgb(54, 0, 235)",
        pointBackgroundColor: "rgb(54, 162, 0)",
        data: [
            this.dContext,
            this.dLeadership,
            this.dPlanning,
            this.dSupport,
            this.dOperation,
            this.dPerformance,
            this.dAudit,
            this.dImprovement,
            this.dLearning,
        ],
        },
    ],
    options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
        position: "top",
        },
        title: {
        display: true,
        text: "",
        },
        scale: {
        ticks: {
            beginAtZero: true,
            max: 5,
            min: 0,
            stepSize: 1,
        },
        },
        tooltips: {
        enabled: false,
        callbacks: {
            label: function (tooltipItem, data) {
            var datasetLabel =
                data.datasets[tooltipItem.datasetIndex].label || "";
            //This will be the tooltip.body
            return (
                datasetLabel +
                ": " +
                tooltipItem.yLabel +
                ": " +
                data.datasets[tooltipItem.datasetIndex].notes[
                tooltipItem.index
                ]
            );
            },
        },
        custom: function (tooltip) {
            // Tooltip Element
            var tooltipEl = document.getElementById("chartjs-tooltip");
            if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.id = "chartjs-tooltip";
            tooltipEl.innerHTML = "<table></table>";
            document.body.appendChild(tooltipEl);
            }
            // Hide if no tooltip
            if (tooltip.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
            }
            // Set caret Position
            tooltipEl.classList.remove("above", "below", "no-transform");
            if (tooltip.yAlign) {
            tooltipEl.classList.add(tooltip.yAlign);
            } else {
            tooltipEl.classList.add("no-transform");
            }
            function getBody(bodyItem) {
            return bodyItem.lines;
            }
            // Set Text
            if (tooltip.body) {
            var titleLines = tooltip.title || [];
            var bodyLines = tooltip.body.map(getBody);
            var innerHtml = "<thead>";
            titleLines.forEach(function (title) {
                innerHtml += "<tr><th>" + title + "</th></tr>";
            });
            innerHtml += "</thead><tbody>";
            bodyLines.forEach(function (body, i) {
                var colors = tooltip.labelColors[i];
                var style = "background:" + colors.backgroundColor;
                style += "; border-color:" + colors.borderColor;
                style += "; border-width: 2px";
                var span =
                '<span class="chartjs-tooltip-key" style="' +
                style +
                '"></span>';
                innerHtml += "<tr><td>" + span + body + "</td></tr>";
            });
            innerHtml += "</tbody>";
            var tableRoot = tooltipEl.querySelector("table");
            tableRoot.innerHTML = innerHtml;
            }
            var position = this._chart.canvas.getBoundingClientRect();
            // Display, position, and set styles for font
            tooltipEl.style.opacity = 1;
            tooltipEl.style.left = position.left + tooltip.caretX + "px";
            tooltipEl.style.top = position.top + tooltip.caretY + "px";
            tooltipEl.style.fontFamily = tooltip._fontFamily;
            tooltipEl.style.fontSize = "30px";
            tooltipEl.style.fontStyle = tooltip._fontStyle;
            tooltipEl.style.padding =
            tooltip.yPadding + "px " + tooltip.xPadding + "px";
        },
        },
    },
    };
    this.loaded = true;

    //this.radargraph.renderChart(this.newData, this.options);
  },
  data: () => ({
    profileResponse: [],

    profileID: 0,

    nextStepAudit: "",
    nextStepContext: "",
    nextStepImprovement: "",
    nextStepLeadership: "",
    nextStepLearning: "",
    nextStepOperation: "",
    nextStepPerformance: "",
    nextStepPlanning: "",
    nextStepSupport: "",

    cMaturityLevel: 0,
    cMaturityIndicator: "",
    dMaturityLevel: 0,
    dMaturityIndicator: "",

    cContext: 0,
    cImprovement: 0,
    cLeadership: 0,
    cLearning: 0,
    cOperation: 0,
    cPerformance: 0,
    cPlanning: 0,
    cSupport: 0,
    cAudit: 0,

    dContext: 0,
    dLeadership: 0,
    dLearning: 0,
    dOperation: 0,
    dPerformance: 0,
    dPlanning: 0,
    dSupport: 0,
    dAudit: 0,

    currentStateAverage: 0,
    desiredStateAverage: 0,

    matLevels: [],

    personalityDescription: "",
    personalityLongDescription: "",
    personalityTraits: "",
    personalityTypicalProfile: "",

    changeIndex: 0,
    changeCapability: "",
    changeCapabilityDescription: "",

    currentMatLevelID: 0,
    currentMatLevelIndicator: "",
    currentMatLevelBehavior: "",

    desiredMatLevelID: 0,
    desiredMatLevelIndicator: "",
    desiredMatLevelBehavior: "",

    loaded: false,

    newData: [],
    chartdata: {
      labels: [
        "Context",
        "Leadership",
        "Planning",
        "Support",
        "Operation",
        "Performance",
        "Audit and Review",
        "Improvement",
        "Learning",
      ],
      datasets: [
        {
          label: "Where you are",
          backgroundColor: "rgba(255, 99, 132, 0.2)",
          borderColor: "rgb(255, 0, 132)",
          pointBackgroundColor: "rgb(255, 99, 0)",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          label: "Where you want to be",
          backgroundColor: "rgba(54, 162, 235, 0.2)",
          borderColor: "rgb(54, 0, 235)",
          pointBackgroundColor: "rgb(54, 162, 0)",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "",
      },
      scale: {
        ticks: {
          beginAtZero: true,
          max: 5,
          min: 0,
          stepSize: 1,
        },
      },
      tooltips: {
        enabled: false,
        callbacks: {
          label: function (tooltipItem, data) {
            var datasetLabel =
              data.datasets[tooltipItem.datasetIndex].label || "";
            //This will be the tooltip.body
            return (
              datasetLabel +
              ": " +
              tooltipItem.yLabel +
              ": " //+
              //data.datasets[tooltipItem.datasetIndex].notes[tooltipItem.index]
            );
          },
        },
        custom: function (tooltip) {
          // Tooltip Element
          var tooltipEl = document.getElementById("chartjs-tooltip");
          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.id = "chartjs-tooltip";
            tooltipEl.innerHTML = "<table></table>";
            document.body.appendChild(tooltipEl);
          }
          // Hide if no tooltip
          if (tooltip.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }
          // Set caret Position
          tooltipEl.classList.remove("above", "below", "no-transform");
          if (tooltip.yAlign) {
            tooltipEl.classList.add(tooltip.yAlign);
          } else {
            tooltipEl.classList.add("no-transform");
          }
          function getBody(bodyItem) {
            return bodyItem.lines;
          }
          // Set Text
          if (tooltip.body) {
            var titleLines = tooltip.title || [];
            var bodyLines = tooltip.body.map(getBody);
            var innerHtml = "<thead>";
            titleLines.forEach(function (title) {
              innerHtml += "<tr><th>" + title + "</th></tr>";
            });
            innerHtml += "</thead><tbody>";
            bodyLines.forEach(function (body, i) {
              var colors = tooltip.labelColors[i];
              var style = "background:" + colors.backgroundColor;
              style += "; border-color:" + colors.borderColor;
              style += "; border-width: 2px";
              var span =
                '<span class="chartjs-tooltip-key" style="' +
                style +
                '"></span>';
              innerHtml += "<tr><td>" + span + body + "</td></tr>";
            });
            innerHtml += "</tbody>";
            var tableRoot = tooltipEl.querySelector("table");
            tableRoot.innerHTML = innerHtml;
          }
          var position = this._chart.canvas.getBoundingClientRect();
          // Display, position, and set styles for font
          tooltipEl.style.opacity = 1;
          tooltipEl.style.left = position.left + tooltip.caretX + "px";
          tooltipEl.style.top = position.top + tooltip.caretY + "px";
          tooltipEl.style.fontFamily = tooltip._fontFamily;
          tooltipEl.style.fontSize = "30px";
          tooltipEl.style.fontStyle = tooltip._fontStyle;
          tooltipEl.style.padding =
            tooltip.yPadding + "px " + tooltip.xPadding + "px";
        },
      },
    },
  }),
};
</script>

<style scoped lang="scss">
@import "../assets/css/mdb.css";

.btn-primary {
  background-color: #33013d !important;
  border: 2px solid #cacaca !important;
}

.btn-primary:hover {
  background-color: rgb(0, 155, 219) !important;
}

.circle {
  background-color: rgb(0, 155, 219) !important;
}

canvas {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

#chartjs-tooltip {
  opacity: 1;
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border-radius: 3px;
  -webkit-transition: all 0.1s ease;
  transition: all 0.1s ease;
  pointer-events: none;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
}

#chartjs-radar {
  width: 40%;
  height: 40%;
}

.chartjs-tooltip-key {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 10px;
}

.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

/*spinner styles*/
.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Add animation to "page content" */
.animate-bottom {
  position: relative;
  -webkit-animation-name: animatebottom;
  -webkit-animation-duration: 1s;
  animation-name: animatebottom;
  animation-duration: 1s;
}

@-webkit-keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0;
  }
  to {
    bottom: 0px;
    opacity: 1;
  }
}

@keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0;
  }
  to {
    bottom: 0;
    opacity: 1;
  }
}
</style>
